import { render, staticRenderFns } from "./addVchicle.vue?vue&type=template&id=2c9327d0&scoped=true"
import script from "./addVchicle.vue?vue&type=script&setup=true&lang=js"
export * from "./addVchicle.vue?vue&type=script&setup=true&lang=js"
import style0 from "./addVchicle.vue?vue&type=style&index=0&id=2c9327d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9327d0",
  null
  
)

export default component.exports